export const DefaultCard = (props) => {
  return (
    <div
      className={`rounded-xl shadow-special max-w-[600px] ${props.className}`}
    >
      {props.children}
    </div>
  );
};
